export default __webpack_public_path__ + "static/media/leftist-desktop.e1a6cc8a.jpg";